
export const addDays = (date, days) => {
  var result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

export function formatYYYYMMDD(dateObj) {
  const date = toDate(dateObj);
  var dd = date.getDate();
  var mm = date.getMonth() + 1; //January is 0!

  var yyyy = date.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  } 
  if (mm < 10) {
    mm = '0' + mm;
  } 
  return (`${yyyy}-${mm}-${dd}`)
}

export function toDate(dateObj){
  if (!dateObj) return null;
  if (typeof dateObj === 'string') {
    return new Date(dateObj);
  } else {
    return dateObj;
  }
}